import { AuthConfig } from "@auth0/auth0-angular";
import { environment } from "../../environments/environment";

export const authConfig: AuthConfig = {
    domain: environment.auth0Domain,
    clientId: environment.auth0ClientId,
    authorizationParams: {
      redirect_uri: window.location.origin + '/callback',
      audience: environment.auth0Audience,
      scope: 'openid profile email offline_access'
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    useRefreshTokensFallback: false
  };

  